<template>
  <div>
    <div
      class="drive-wrapper drive-grid-view"
      style="height: 65vh;"
      v-if="resources.length > 0"
    >
      <div
        class="grid-items-wrapper ts-overflow-y-auto ts-overflow-x-hidden"
        style="max-height: 65vh;"
      >
        <div
          class="drive-item module text-center"
          v-for="(entry, index) in resources"
          :key="index"
        >
          <div
            class="drive-item-inner module-inner ts-cursor-pointer"
            @dblclick="onOpen(entry.data)"
          >
            <div class="drive-item-title">
              <a @click="onOpen(entry.data)">{{
                entry.data.attributes.name
              }}</a>
              <br />
              <small class="ts-opacity-5">{{
                entry.data.attributes.updated_at
              }}</small>
            </div>
            <div class="drive-item-thumb" v-viewer="{ toolbar: false }">
              <!--Folder Icon-->
              <a v-if="entry.data.type == 'folder'"
                ><i class="fas fa-folder fa-5x text-primary"></i
              ></a>

              <!--File Icon-->
              <a v-else @click="onOpen(entry.data)">
                <file-icon-thumbnail
                  :entry="entry"
                  :icon-size="iconSize"
                  class="pr-2"
                />
              </a>
            </div>
          </div>
          <div class="drive-item-footer module-footer">
            <ul class="utilities list-inline">
              <li>
                <a @click.prevent="download(entry.data)" v-tooltip="'Download'"
                  ><i class="fa fa-download"></i
                ></a>
              </li>
              <li>
                <a @click.prevent="remove(entry.data)" v-tooltip="'Delete'"
                  ><i class="fa fa-trash"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="drive-wrapper drive-grid-view"
      style="height: 65vh;"
      @contextmenu.prevent="onRightClick"
      v-else
    >
      <div class="ts-mt-64 text-center">
        <h1 class="ts-font-bold text-info ts-text-sm">
          {{ $t('fileManager.uploadYourFirstFileOrFolder') }}
        </h1>
        <p class="ts-text-xs ts-text-gray-500 ts-mb-2 ts-mt-1">
          {{ $t('fileManager.uploadSomeFileHearEasilyVaiUpload') }}
        </p>
        <ts-button
          outline
          color="info"
          @click.prevent="uploadFile"
          :disabled="!currentFolderId"
        >
          {{ $t('fileManager.uploadFile') }}
        </ts-button>
      </div>
      <vue-context ref="menu">
        <li v-for="(m, i) in menus" :key="i">
          <a
            @click.prevent="handle_function_call(m.action_name)"
            :disabled="!currentFolderId && m.action_name === 'uploadFile'"
            ><i class="ts-mr-3" :class="m.icon"></i> {{ m.name }}</a
          >
        </li>
      </vue-context>
    </div>
    <a-modal
      v-model="create_folder_show"
      :title="$t('fileManager.createFolder')"
      @cancel="() => (create_folder_show = false)"
      width="20%"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
    >
      <create-folder-component
        :data="{ id: currentFolderId }"
        @close="() => (create_folder_show = false)"
      />
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FileIconThumbnail from './FileIconThumbnail'
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
import AudioComponent from './audio'
import VideoComponent from './video'
import PreviewPdfComponent from './preview-pdf'
import * as FileDownload from 'downloadjs'
import VueContext from 'vue-context'
import CreateFolderComponent from './create-folder.vue'
import UploadFileComponent from './upload-files-popup.vue'
export default {
  name: 'grid-view',
  props: ['itemType'],
  components: {
    FileIconThumbnail,
    VueContext,
    CreateFolderComponent
  },
  data () {
    return {
      iconSize: 'fa-5x',
      loading: false,
      removing: false,
      create_folder_show: false,
      menu: [
        {
          name: 'Upload Files',
          action_name: 'uploadFile',
          icon: 'fas fa-file-upload',
          is_directory: true,
          display_root: false
        },
        {
          name: 'Create Folder',
          action_name: 'createFolder',
          icon: 'fas fa-folder-plus',
          is_directory: true,
          display_root: true
        },
        {
          name: 'Upload Folder',
          action_name: 'uploadFolder',
          icon: 'fas fa-folder',
          is_directory: true,
          display_root: true
        }
      ]
    }
  },
  computed: {
    ...mapState('fileManager/fileBrowser', [
      'entries',
      'currentFolderId',
      'currentFolder'
    ]),
    resources () {
      if (this.itemType) {
        if (this.itemType == 'media_file') {
          return this.entries.filter(
            e => e.data.type == 'audio' || e.data.type == 'video'
          )
        }
        return this.entries.filter(e => e.data.type == this.itemType)
      }
      return this.entries
    },
    menus () {
      return this.menu
    }
  },
  methods: {
    handle_function_call (function_name) {
      this[function_name]()
    },
    uploadFile () {
      this.$modal.show(
        UploadFileComponent,
        {
          data: {
            id: this.currentFolder.data.id,
            name: this.currentFolder.data.attributes.name
          }
        },
        {
          height: 'auto',
          width: '800px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.getCurrentFolder
        }
      )
    },
    uploadFolder () {
      this.$toasted.info('Under Construction!')
    },
    createFolder () {
      this.create_folder_show = true
    },
    onRightClick (e) {
      this.$refs.menu.open(e)
    },
    getCurrentFolder () {
      this.loading = true
      this.$store
        .dispatch('fileManager/fileBrowser/getFolder', this.currentFolderId)
        .finally(() => {
          this.loading = false
        })
    },
    async onOpen (data) {
      if (data.type === 'folder') {
        this.$store.commit(
          'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
          data.id
        )
        this.$router.push({
          name: 'file-manager-folder',
          params: { id: data.id }
        })
        this.$emit('fetchCurrentFolder')
      }
      if (data.type === 'video') {
        this.showVideoForm(data.attributes)
      }
      if (data.attributes.mimetype === 'pdf') {
        this.showPdfForm(data.attributes)
      }
      if (
        data.attributes.mimetype ===
        'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
      if (
        data.attributes.mimetype ===
        'vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
      if (
        ['mpeg', 'mp3', 'mp4', 'wan', 'flac', 'ogg'].includes(
          data.attributes.mimetype
        ) &&
        data.type === 'audio'
      ) {
        this.showAudioForm(data.attributes)
      }
      if (data.attributes.mimetype === 'zip') {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
      if (data.attributes.mimetype === 'plain') {
        if (
          await this.$confirmModal.danger(
            'Are you sure to download ' + data.attributes.name + '?'
          )
        ) {
          FileDownload(data.attributes.file_url)
        }
      }
    },
    showAudioForm (data) {
      this.$modal.show(
        AudioComponent,
        {
          data: { file_url: data.file_url, name: data.name }
        },
        {
          height: 'auto',
          width: '500px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    showVideoForm (data) {
      this.$modal.show(
        VideoComponent,
        {
          data: { file_url: data.file_url, name: data.name }
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    showPdfForm (data) {
      this.$modal.show(
        PreviewPdfComponent,
        {
          data: { file_url: data.file_url, name: data.name }
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    download (data) {
      FileDownload(data.attributes.file_url)
    },
    async remove (data) {
      if (
        await this.$confirmModal.danger(
          'Are you sure to delete ' + data.attributes.name + '?'
        )
      ) {
        this.removing = true
        this.$store
          .dispatch('fileManager/fileFunction/deleteItem', {
            items: [
              {
                force_delete: data.attributes.items > 0 ? true : false,
                id: data.id,
                type: data.type
              }
            ]
          })
          .then(() => {
            this.$emit('fetchCurrentFolder')
            if (data.type === 'folder') {
              this.$emit('fetchNav')
            }
          })
          .finally(() => {
            this.removing = false
          })
      }
    }
  }
}
</script>
